import React from 'react';
import cn from 'classnames';
import Container from 'components/UI/Container';
import Title from 'components/UI/Title';
import Bullets from 'features/common/Bullets';
import Cases from 'components/Cases/Cases';
import CustomTestimonials from '../CustomTestimonials';

import * as styles from './GalleryStyles.module.scss';

export default function F500Gallery({
  active,
  fadeInAnimation,
  id,
  title,
  projects,
  feature,
  testimonials,
}) {
  return (
    <div className={cn(styles.gallery, active !== id && styles.hidden)}>
      <Container margin="None" className={styles.container}>
        <div className={cn(styles.wrapper, fadeInAnimation ? styles.fadeInAnimation : undefined)}>
          <Title tag="h2" size="h3">
            {title}
          </Title>
          <Cases
            projects={projects.slice(0, 2)}
            className={cn(styles.cases, styles.marginTop, styles.marginBottom)}
            gallery={active}
          />
          <Bullets {...feature} className={styles.bullets} />
          <Cases
            projects={projects.slice(2, 6)}
            className={cn(styles.cases, styles.marginTop)}
            layout="projects-mirrored"
            gallery={active}
          />
        </div>
      </Container>
      <CustomTestimonials
        items={testimonials}
        className={fadeInAnimation ? styles.fadeInAnimation : undefined}
      />
      <Container margin="None" className={styles.container}>
        <div className={cn(styles.wrapper, fadeInAnimation ? styles.fadeInAnimation : undefined)}>
          <Cases
            projects={projects.slice(6)}
            className={cn(styles.cases, styles.marginTopNone)}
            gallery={active}
          />
        </div>
      </Container>
    </div>
  );
}
